import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  Divider,
  useTheme,
} from "@mui/material";
import { Email, Phone, LocationOn, Business } from "@mui/icons-material";

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper,
        py: 2,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        {/* <Divider sx={{ my: 3, borderColor: "rgba(255, 255, 255, 0.2)" }} /> */}

        {/* Bottom Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} Sistema Integrado de Pedidos. Todos los
            derechos reservados.
          </Typography>
          <Box sx={{ display: "flex", gap: 3 }}>
            <Link
              href="https://www.kossok.com.ar/p/programa-compra-protegida"
              color="inherit"
              sx={{
                textDecoration: "none",
                opacity: 0.8,
                "&:hover": { opacity: 1 },
              }}
            >
              ¿Cómo comprar?
            </Link>
            <Link
              href="https://www.kossok.com.ar/p/privacidad"
              color="inherit"
              sx={{
                textDecoration: "none",
                opacity: 0.8,
                "&:hover": { opacity: 1 },
              }}
            >
              Política de Privacidad
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
